<template>
    <div v-bind:class="[ 'select-col', 'component-' + box.component]">
        <div class="top-step-name basic-border basic-color">{{ box.title }}</div>
        <!-- SEARCHBOX -->

        <!-- FILTERBOXES -->
        <div class="designer-detailbox-description">
            <p><span id="detail-description">{{{ box.todo }}}</span></p>
        </div>
        <div class="fabric-select-btn-box">
            <div class="top-arrow hasTop" v-if="box.component == 'buttons'">
                <div class="top-arrow-text">Hochscrollen für weitere Muster</div>
            </div>
            <div :id="box.component" class="fabric-select-btns">

                <div v-for="item in items"
                     v-bind:class="[ 'fabric-select-btn', isactive === item.ref_number ? 'active' : '' ]">
                    <img v-bind:src="this.baseurl + 'media/' + item.thumb" v-bind:alt="item.name"
                         v-bind:title="item.name" v-bind:id="item.ref_number" @click="updatePersonal"
                         v-bind:data-component="box.component"
                         v-bind:data-btncolor="item.color_code"/>
                    <div class="name" v-bind:id="item.ref_number" @click="updatePersonal"
                         v-bind:data-component="box.component"
                         v-bind:data-btncolor="item.color_code">{{ item.name }}
                    </div>
                    <button v-bind:class="[ 'zoom-btn', 'btn-standalone', (isactive === itemref_number || item.ref_number === this.personal[box.component]) ? 'active' : '' ]"
                            v-bind:data-refnr="item.ref_number"
                            v-bind:data-title="item.name" v-bind:data-infotext='item.infotext'
                            v-bind:data-price='item.price'
                            type="button" @click="zoomFabric">Details
                    </button>
                </div>
            </div>
        </div>
        <div class="bottom-arrow hasTop" v-if="box.component == 'buttons'">
            <div class="bottom-arrow-text">Runterscrollen für weitere Muster</div>
        </div>

        <div class="designer-select-dropdown" v-if="personal['bags'] !== 'none'">

            <div class="designer-select-dropdown-col">

                <h3>Position</h3>

                <div id="bagsposition" class="designer-select">
                    <select title="Position" id="bagsposition" name="Position" id="bagsposition" v-model="selected"
                            @change="updatePersonalBags">
                        <option value="left">links</option>
                        <option value="right">rechts</option>
                        <option value="both">beidseitig</option>
                    </select>
                </div>
            </div>
        </div>
    </div>
    <zoom v-if="zoom" :zoom="zoom" :show.sync="show" :globals="globals"></zoom>
</template>


<script>
import Zoom from '../partials/Zoom.vue'

export default {
  name: 'Bags',
  data: function () {
    return {
      selected: (typeof this.personal['bagsposition'] !== 'undefined' ? this.personal['bagsposition'] : ''),
      globals: window.shirtdesigner,
      show: {
        type: Boolean,
        required: true,
        twoWay: true
      }
    }
  },
  props: [ 'fabrics', 'items', 'box', 'filtertext', 'zoom', 'show', 'baseurl', 'personal', 'isactive' ],
  components: {
    Zoom
  },
  methods: {
    updatePersonal: function (event) {
      this.$dispatch('updatePersonalData', [event.currentTarget.dataset.component, event.currentTarget.id])
      this.isactive = event.currentTarget.id
      if (event.currentTarget.id === 'none') {
        this.$dispatch('updatePersonalData', ['bagsposition', ''])
      } else if (this.personal['bagsposition'] === '') {
        this.$dispatch('updatePersonalData', ['bagsposition', 'left'])
      }
      if (event.currentTarget.id === 'none' && (this.personal['monopos'] === 'pocketleft' || this.personal['monopos'] === 'pocketright')) {
        this.$dispatch('updatePersonalData', ['monogramm', ''])
        this.$dispatch('updatePersonalData', ['monopos', 'waistleft'])
      }
    },
    updatePersonalBags: function (event) {
      this.$dispatch('updatePersonalData', [event.currentTarget.id, this.selected])
      if (this.selected === 'left' && this.personal['monopos'] === 'pocketright') {
        this.$dispatch('updatePersonalData', ['monogramm', ''])
        this.$dispatch('updatePersonalData', ['monopos', 'waistleft'])
      } else if (this.selected === 'right' && this.personal['monopos'] === 'pocketleft') {
        this.$dispatch('updatePersonalData', ['monogramm', ''])
        this.$dispatch('updatePersonalData', ['monopos', 'waistleft'])
      }
    },
    zoomFabric: function (event) {
      this.zoom = {
        img: this.baseurl + 'media/jack/shirt/zoom/' + this.box.component + '_' + event.currentTarget.dataset.refnr + '.jpg',
        title: event.currentTarget.dataset.title,
        infotext: event.currentTarget.dataset.infotext,
        weight: event.currentTarget.dataset.weight,
        composition: event.currentTarget.dataset.composition,
        weave: event.currentTarget.dataset.weave,
        yarn: event.currentTarget.dataset.yarn,
        refnr: event.currentTarget.dataset.refnr,
        price: Number(event.currentTarget.dataset.price).toFixed(2)
      }
      this.show = true
    }
  },
  ready: function () {
    this.$dispatch('runDesignJQuery')
  }
}

</script>



// WEBPACK FOOTER //
// Bags.vue?100ca3cd